import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'GRUPO_CLIENTE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'GRUPO_CLIENTE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('grupoClienteForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/grupoCliente?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'GRUPO_CLIENTE_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/grupoCliente`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/grupoCliente`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/grupoCliente?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaGrupo() {
    const request = axios.get(`${consts.API_URL}/grupoCliente/listarSelect`);
    return {
        type: 'GRUPO_CLIENTE_GRUPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelectGeral`);
    return {
        type: 'GRUPO_CLIENTE_CIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function importar(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));
		let listaCliente = [];
		let listaEndereco = [];

		for (var i = 0; i < tabela.length; i++) {
			let item = tabela[i];

			let grupoCliente = {
				id_petroshow: String(item[2] || '').trim(),
				razao_social: String(item[3] || '').trim().substring(0, 299).trim(),
				nome_fantasia: String(item[4] || '').trim().substring(0, 299).trim(),
				cnpj: String(item[5] || '').trim().length == 14 ? item[5] : null,
				cpf: String(item[5] || '').trim().length == 14 ? null : item[5],
				id_tipo: String(item[5] || '').trim().length == 14 ? 2 : 1,
				inscricao_estadual: item[6],
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			};

			let endereco = {
				id_petroshow: null,
				id_petroshow_grupoCliente: item[2],
				id_grupoCliente: null,
				codigo_vendedor: item[8],
				endereco: String(item[16] || '').trim().substring(0, 299).trim(),
				bairro: '',
				numero: String(item[18] || '').trim().substring(0, 149).trim(),
				id_cidade: null,
				telefone: FormatUtils.removerMascara(String(item[10] || '')).trim().substring(0, 11).trim(),
				celular: FormatUtils.removerMascara(String(item[12] || '')).trim().substring(0, 11).trim(),
				latitude: String(item[19] || '').trim().substring(0, 19).trim(),
				longitude: String(item[20] || '').trim().substring(0, 19).trim(),
				croqui: null,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}

			if (!listaCliente.filter(cli => cli.id_petroshow == grupoCliente.id_petroshow).length && grupoCliente.id_petroshow 
					&& grupoCliente.razao_social && grupoCliente.nome_fantasia && (grupoCliente.cpf || grupoCliente.cnpj) && endereco.endereco) {
				listaCliente.push(grupoCliente);
			}
			if (endereco.endereco) {
				listaEndereco.push(endereco);		
			}
			
		}

		await axios.post(`${consts.API_URL}/grupoCliente/importar`, {
			lista: listaCliente
		}).then(resp => {
		}).catch(e => {
			setErroAPI(e);
		});

		await axios.post(`${consts.API_URL}/endereco/importar`, {
			lista: listaEndereco
		}).then(resp => {
		}).catch(e => {
			setErroAPI(e);
		});

		setSuccess('Importação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setAguardando(false));
    };
}
